
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my/notes",
      function () {
        return require("private-next-pages/my/notes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my/notes"])
      });
    }
  